import React, { useEffect, useState } from "react";
import moment from "moment";
import "./AppointmentScheduler.css";

// Componentes
import AppointmentStep from "./components/AppointmentStep";
import PatientStep from "./components/PatientStep";
import DocumentsStep from "./components/DocumentsStep";
import InfoStep from "./components/InfoStep";
import ConfirmationStep from "./components/ConfirmationStep";
import QueueModal from "./components/QueueModal";
import DoctorInfoCard from "./components/DoctorInfoCard";
import LocationInfoCard from "./components/LocationInfoCard";
import ProgressTracker from "./components/ProgressTracker";
import { getContactsRead, getDisponibilidad, postCitas } from "../../helpers/backend";
import { useSelector } from "react-redux";
import { handleHttpAlert } from "../../utils/handleHttpAlert";

const AppointmentScheduler = ({ setupData }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [showQueueForm, setShowQueueForm] = useState(false);
  const [patientInfo, setPatientInfo] = useState({
    name: "",
    id: "",
    email: "",
    phone: "",
    insurance: "",
    reason: ""
  });
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [appointmentConfirmed, setAppointmentConfirmed] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [doctorInfo, setDoctorInfo] = useState([]);
  const [availableHours, setAvailableHours] = useState([]);
  const [locationInfo, setLoationInfo] = useState([]);

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setSelectedTime(null);
    getAvailableData(date);
  };

  const getDoctorInfo = async () => {
    const response = await getContactsRead(setupData.contact);
    setDoctorInfo(response.data);
    console.log(response.data);
    
  };

  const getAvailableData = async (date) => {
    if (!date) return;

    const formattedDate = moment(date).format("YYYY-MM-DD");
    try {
      const response = await getDisponibilidad(setupData.contact, formattedDate);
      setAvailableHours(response.data.intervalos_disponibles);
    } catch (error) {
      console.error("Error al obtener disponibilidad:", error);
    }
  };

  const handleTimeSelect = (time) => {
    setSelectedTime(time);
    setSelectedAppointment({
      id: Date.now(),
      date: selectedDate.toLocaleDateString("es-ES", {
        day: "numeric",
        month: "long"
      }),
      time: time
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPatientInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleConfirmAppointment = async () => {
    if (!patientInfo.name || !patientInfo.id || !patientInfo.phone) {
      alert("Por favor complete los campos obligatorios");
      return;
    }

    if (!selectedDate || !selectedTime) {
      alert("Por favor seleccione fecha y hora");
      return;
    }

    const startDateTime = moment(selectedDate).format("YYYY-MM-DD") + " " + selectedTime + ":00";
    const endDateTime = moment(selectedDate)
      .set({ hour: parseInt(selectedTime.split(":")[0]) + 1, minute: 0 })
      .format("YYYY-MM-DD HH:mm:ss");

    const archivos = uploadedDocuments.map((doc) => ({
      archivo: doc.base64?.split(",")[1],
      descripcion: doc.name
    }));

    const dataJSON = {
      title: patientInfo.name || "Consulta",
      descripcion: patientInfo.reason || "Consulta médica",
      start: startDateTime,
      end: endDateTime,
      observaciones: "",
      entidad: setupData.branch.id,
      especialidad: setupData.specialty.id,
      profesional: doctorInfo.id,
      cliente: patientInfo.id,
      archivos
    };
      const response = await postCitas(dataJSON)
    console.log(response);
    await handleHttpAlert(
              response,
              "¡Cita agendada!",
              "Se ha agendado tu cita correctamente.",
              "No se pudo crear la cita"
            );

    setAppointmentConfirmed(true);
    setCurrentStep(5);
  };

  const handleFileUpload = (files) => {
    setUploadedDocuments((prev) => [...prev, ...files]);
  };

  const removeDocument = (id) => {
    setUploadedDocuments(uploadedDocuments.filter((doc) => doc.id !== id));
  };

  const handleQueueSubmit = (e) => {
    e.preventDefault();
    alert(`Gracias ${patientInfo.name}. Te hemos agregado a la cola de espera. Te contactaremos pronto.`);
    setShowQueueForm(false);
    setPatientInfo((prev) => ({ ...prev, name: "", phone: "", reason: "" }));
  };

  const resetForm = () => {
    setCurrentStep(1);
    setSelectedAppointment(null);
    setAppointmentConfirmed(false);
    setSelectedDate(null);
    setSelectedTime(null);
    setPatientInfo({
      name: "",
      id: "",
      email: "",
      phone: "",
      insurance: "",
      reason: "",
      documentNumber: ""
    });
    setUploadedDocuments([]);
  };

  useEffect(() => {
    if (setupData) {
      getDoctorInfo();
      setLoationInfo(setupData.branch);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
console.log(patientInfo)

const theme = useSelector((state) => state.theme.theme) || "light";

  return (
    <div className="appointment-container">
      <div className="sidebar" style={{borderRight: theme === 'dark' ? '1px solid #3b3b3b' : ''}}>
        <DoctorInfoCard doctorInfo={doctorInfo} specialty={setupData.specialty} />
        <LocationInfoCard locationInfo={locationInfo} />
        <ProgressTracker currentStep={currentStep} />
      </div>

      <div className="main-content-cita" style={{ borderBottom:"none" }}>
        {currentStep === 1 && (
          <AppointmentStep
            selectedDate={selectedDate}
            selectedTime={selectedTime}
            availableHours={availableHours}
            onDateSelect={handleDateSelect}
            onTimeSelect={handleTimeSelect}
            onJoinQueue={() => setShowQueueForm(true)}
            onNextStep={() => setCurrentStep(2)}
          />
        )}

        {currentStep === 2 && (
          <PatientStep
            patientInfo={patientInfo}
            onInputChange={handleInputChange}
            onBack={() => setCurrentStep(1)}
            onNextStep={() => setCurrentStep(3)}
          />
        )}

        {currentStep === 3 && (
          <DocumentsStep
            uploadedDocuments={uploadedDocuments}
            onFileUpload={handleFileUpload}
            onRemoveDocument={removeDocument}
            onBack={() => setCurrentStep(2)}
            onNextStep={() => setCurrentStep(4)}
          />
        )}

        {currentStep === 4 && (
          <InfoStep
            locationInfo={locationInfo}
            onBack={() => setCurrentStep(3)}
            onConfirm={() => setCurrentStep(5)}
          />
        )}

        {currentStep === 5 && (
          <ConfirmationStep
            appointmentConfirmed={appointmentConfirmed}
            selectedAppointment={selectedAppointment}
            patientInfo={patientInfo}
            doctorInfo={doctorInfo}
            locationInfo={locationInfo}
            uploadedDocuments={uploadedDocuments}
            onConfirmAppointment={handleConfirmAppointment}
            onResetForm={resetForm}
            onBack={() => setCurrentStep(4)}
          />
        )}
      </div>

      {showQueueForm && (
        <QueueModal
          patientInfo={patientInfo}
          onInputChange={handleInputChange}
          onSubmit={handleQueueSubmit}
          onClose={() => setShowQueueForm(false)}
        />
      )}
    </div>
  );
};

export default AppointmentScheduler;
